var React = require('react');

function ReturnArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#FFF","cx":"32.001","cy":"32.001","r":"31.22","key":0}),React.createElement("path",{"fill":"#E6E6E6","d":"M32 64C14.354 64 0 49.646 0 32S14.354 0 32 0s32 14.354 32 32-14.354 32-32 32zm0-62.439C15.216 1.561 1.561 15.216 1.561 32S15.216 62.439 32 62.439 62.439 48.784 62.439 32 48.784 1.561 32 1.561z","key":1}),React.createElement("path",{"fill":"#FF9C00","d":"M14.917 32l2.704-2.705 10.787 10.788-2.704 2.704z","key":2}),React.createElement("path",{"fill":"#FF9C00","d":"M14.917 32l10.787-10.788 2.704 2.704L17.62 34.703z","key":3}),React.createElement("path",{"fill":"#FF9C00","d":"M17.621 30.088h31.652v3.824H17.621z","key":4})]);
}

ReturnArrow.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = ReturnArrow;

ReturnArrow.default = ReturnArrow;
